export default __webpack_public_path__ + "static/media/title-termsIcon.da2842d5.svg";